import { useState } from 'react'
import { motion } from 'framer-motion'
import { FileText, Search, Filter } from 'lucide-react'
import { PageHeader, useAuthStore, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'

export default function ComplianceAudit() {
  const { user } = useAuthStore()
  const breadcrumbs = buildBreadcrumbs('/settings/compliance/audit')
  const [searchQuery, setSearchQuery] = useState('')

  const isStaff = user?.role === 'employee' || user?.role === 'superuser'

  return (
    <div>
      <PageHeader
        title="Global Audit Log"
        description="Comprehensive record of all actions and changes within your organization."
        breadcrumbs={breadcrumbs}
      />

      <div className="max-w-5xl">
        {/* Search/Filter bar */}
        <motion.div variants={fadeUp} initial="hidden" animate="visible" className="flex gap-3 mb-6">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-warm-400" />
            <input
              type="text"
              placeholder="Search audit log..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-warm-200 text-sm focus:outline-none focus:border-copper-400 focus:ring-1 focus:ring-copper-400"
            />
          </div>
          <button className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-warm-200 text-sm text-warm-700 hover:border-copper-300 transition-colors">
            <Filter className="w-4 h-4" />
            Filters
          </button>
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" animate="visible" className="rounded-xl border border-warm-200 bg-white p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-copper-50 flex items-center justify-center">
              <FileText className="w-5 h-5 text-copper-500" />
            </div>
            <h2 className="font-heading font-semibold text-midnight-800">Audit Entries</h2>
          </div>
          <p className="text-sm text-warm-500 text-center py-8">
            {isStaff
              ? 'Audit log entries will appear here. Use filters to narrow results.'
              : 'Audit log access requires the compliance audit feature. Contact your administrator.'}
          </p>
        </motion.div>
      </div>
    </div>
  )
}
